import Navigation from "./components/Navigation";

const App: React.FC = () => <Navigation />;

export default App;
